import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  BasicSelect
} from 'vue-search-select';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'UpdateStatus',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect
  },
  mixins: [PageTracker],
  data: function() {
    return {
      ShipmentId: '',
      StatusList: [{
        text: "Shipped-Inscan"
      }, {
        text: "Shipped-Handover"
      }, {
        text: "RTO-Inscan"
      }],
      statusObj: {
        text: ""
      },
      status: '',
      // ShipmentStatusList: [{
      //   text: "Handover"
      // }, {
      //   text: "Inscan"
      // }],
      // ShipmentstatusObj: {
      //   text: ""
      // },
      // Shipmentstatus: '',
      isLoading: false,
      userDataKey : ''
    }
  },
  created: function() {

  },
  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.Update();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    Update() {
        let MergedStatus = this.status.split('-');
      this.input = {
        "ShippingId": this.ShipmentId.trim(),
        "Status": MergedStatus[0],
        "ShipmentStatus": MergedStatus[1],
        "LastModifiedBy": this.localusermailid
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/update/shipment/status',
          data: this.input
        })
        .then(async result => {
          if (result.data.code == 200) {
            let TrackerInfo = {
              projectname:"Last Mile",
              type: "Web",
              userid: this.localuserid,
              username: this.localusermailid,
              meta: {
                  "event": "updateShipmentStatus",
                  "ShippingID": this.ShipmentId.trim().toString(),
                  "Status": MergedStatus[0]              
                }
            }
            this.PageTracker(TrackerInfo);
            this.$alertify.success(result.data.message);
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
          this.clear();
          MergedStatus = [];
        })
    },
    selectStatus(obj) {
      this.statusObj = obj;
      this.status = obj.text;
    },
    // selectShipmentStatus(obj) {
    //   this.ShipmentstatusObj = obj;
    //   this.Shipmentstatus = obj.text;
    // },
    clear() {
      this.$validator.reset();
      this.ShipmentId = '';
      this.status = '';
      // this.Shipmentstatus = '';
      // this.ShipmentstatusObj = {};
      this.statusObj = {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateStatus/UpdateStatus.component.js